import React, { useState, useEffect } from "react";
import NavbarHeader from "../Navbar";
import style from "./accountStyle.module.css";
import FooterBfsg from "../FooterBfsg";
import {
  COntactName,
  ChooseBrand,
  QuestionMark,
  Picture,
  StoreName,
  Describe,
  Gmail,
} from "./svgIcon";

function CreateAccount() {
  const [sellMethod, setSellMethod] = useState("");
  const [brands, setBrands] = useState(new Set());

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    const timestamp = () => {
      const response = document.getElementById("g-recaptcha-response");
      if (response == null || response.value.trim() === "") {
        const field = document.getElementsByName("captcha_settings")[0];
        if (!field) return;
        const elems = JSON.parse(field.value);
        elems.ts = JSON.stringify(new Date().getTime());
        field.value = JSON.stringify(elems);
      }
    };
    const interval = setInterval(timestamp, 500);

    return () => {
      clearInterval(interval);
      script.remove();
    };
  }, []);

  const toggleBrand = (val) => {
    const next = new Set(brands);
    if (next.has(val)) next.delete(val);
    else next.add(val);
    setBrands(next);
  };

  const onSubmit = () => {
    const hiddenBrands = document.getElementById("sf-manufacturer-hidden");
    hiddenBrands.value = Array.from(brands).join(";");
  };

  return (
    <div>
      <section>
        <NavbarHeader />
        <div className="container">
          <div className={style.WholesaleFormMain}>
            <h3>Apply for a Wholesale Account with One of Our Brands!</h3>

            {/* POST directly to Salesforce Web-to-Lead without changing your UI */}
            <form
              action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D30000001G9fh"
              method="POST"
              onSubmit={onSubmit}
            >
              {/* required hidden fields */}
              <input
                type="hidden"
                name="captcha_settings"
                className={style.hiddenField}
                value='{"keyname":"google","fallback":"true","orgId":"00D30000001G9fh","ts":""}'
              />
              <input
                type="hidden"
                name="oid"
                className={style.hiddenField}
                value="00D30000001G9fh"
              />
              <input
                type="hidden"
                name="retURL"
                className={style.hiddenField}
                value="http://beautyfashionsales.com"
              />

              <div className={style.detailFilling}>
                <div className={style.innerInformation}>
                  <div className={style.SvgLogo}>
                    <COntactName />
                  </div>
                  <div className={style.labelDivMain}>
                    <div className={style.labelIN}>
                      <label htmlFor="first_name">First Name</label>
                      <br />
                      <input id="first_name" name="first_name" type="text" />
                    </div>

                    <div className={style.labelIN}>
                      <label htmlFor="last_name">Last Name</label>
                      <br />
                      <input id="last_name" name="last_name" type="text" />
                    </div>
                  </div>
                </div>

                <div className={style.innerInformation}>
                  <div className={style.SvgLogo}>
                    <Gmail />
                  </div>
                  <div className={style.labelDivMain}>
                    <div className={style.labelIN}>
                      <label htmlFor="email">Your Email</label>
                      <br />
                      <input id="email" name="email" type="email" />
                    </div>

                    <div className={style.labelIN}>
                      <label htmlFor="mobile">Phone Number</label>
                      <br />
                      <input id="mobile" name="mobile" type="text" />
                    </div>
                  </div>
                </div>

                <div className={style.innerInformation}>
                  <div className={style.SvgLogo}>
                    <StoreName />
                  </div>
                  <div className={style.labelDivMain}>
                    <div className={style.labelIN}>
                      <label htmlFor="company">Store Name</label>
                      <br />
                      <input id="company" name="company" type="text" />
                    </div>

                    <div className={style.labelIN}>
                      <label>Store Location</label>
                      <br />
                      {/* No SF field provided for this in your sample, leaving unmapped on purpose */}
                      <input type="text" />
                    </div>
                  </div>
                </div>

                <div className={style.innerInformation}>
                  <div className={style.SvgLogo}>
                    <Describe />
                  </div>
                  <div className={style.labelDivMain}>
                    <div className={style.labelIN}>
                      <label htmlFor="description">
                        Describe your Store and target customer
                      </label>
                      <br />
                      <input id="description" name="description" className="w-95" type="text" />
                    </div>
                  </div>
                </div>

          

                {/* How do you sell? -> hidden SF field 00NRb000001SaVU */}
                <div className={style.innerInformationRadio}>
                  <div className={`${style.SvgLogo} ${style.SvgLogo1}`}>
                    <QuestionMark />
                  </div>

                  <div className={style.LabelContro}>
                    <div>
                      <h3>How do you sell to your customers? </h3>
                    </div>

                    {/* hidden field that Salesforce expects */}
                    <input
                      type="hidden"
                      name="00NRb000001SaVU"
                      value={sellMethod}
                    />

                    <div className={style.radioContro}>
                      <div className="row">
                        {[
                          "Local Ads",
                          "Social Media",
                          "Google",
                          "Walking Customer",
                          "One to One",
                          "Beauty Demoes",
                          "Ecommerce Site",
                        ].map((label) => (
                          <div key={label} className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className={` ${style.labelDetail} ${style.labelbox} `}>
                              <label>
                                <input
                                  type="radio"
                                  name="sell-ui-only"
                                  onChange={() => setSellMethod(label)}
                                />{" "}
                                {label}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Brands -> hidden SF multi-select field 00N1400000BBygV */}
                <div className={style.innerInformationRadio}>
                  <div className={`${style.SvgLogo} ${style.SvgLogo2}`}>
                    <ChooseBrand />
                  </div>

                  <div className={style.LabelContro}>
                    <div>
                      <h3>Choose Brands to Apply </h3>
                    </div>

                    {/* hidden field that Salesforce expects (semicolon-separated) */}
                    <input
                      type="hidden"
                      id="sf-manufacturer-hidden"
                      name="00N1400000BBygV"
                      defaultValue=""
                    />

                    <div className={style.radioContro}>
                      <div className="row">
                        {[
                          "Estee Lauder",
                          "Maison Margiela",
                          "BUXOM",
                          "Laura Mercier",
                          "Bare Minerals",
                          "Supergoop!",
                          "L’Occitane",
                          "Victoria Beckham Fragrance",
                          "Victoria Beckham Beauty",
                          "Smashbox",
                          "Diptyque",
                          "RMS Beauty",
                          "ReVive",
                          "Kevyn Aucoin Cosmetics",
                          "NEST New York",
                          "Bumble and Bumble",
                          "Omorovicza",
                          "Augustinus Bader",
                        ].map((brand) => (
                          <div key={brand} className="col-lg-4 col-md-4 col-sm-6 col-12">
                            <div className={style.labelDetail}>
                              <label>
                                {/* checkbox purely for UI; we collect into hidden field onSubmit */}
                                <input
                                  type="checkbox"
                                  onChange={(e) => toggleBrand(brand)}
                                />{" "}
                                {brand}
                              </label>
                            </div>
                          </div>
                        ))}

                        <div>
                          <h3>
                            Please list the other top brands you carry, with
                            emphasis on brands in a similar category (i.e. other
                            fragrance, makeup, skincare, or haircare brands).
                          </h3>
                        </div>

                        {/* Competitor Brands -> matches your Web-to-Lead sample */}
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                          <textarea
                            id="00NRb000008Gjar"
                            name="00NRb000008Gjar"
                            rows="4"
                            cols="50"
                            style={{ width: "100%" }}
                          ></textarea>
                        </div>

                        <div className={style.BySigning}>
                          <p>
                            <input type="checkbox" />
                            By signing in or clicking "Apply for an Account", you
                            agree to our Terms of Service Please also read our
                            Privacy Policy
                          </p>

                          <div className={style.captchaWrap}>
                            <div
                              className="g-recaptcha"
                              data-sitekey="6LdQ2ootAAAAAGwM8u8IsX-QpgTi-1RIVaybPRii"
                            ></div>
                          </div>
                          <button type="submit">Apply Now</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>

        <FooterBfsg />
      </section>
    </div>
  );
}

export default CreateAccount;
